import gql from "graphql-tag";

const SELECT_SINGLE_USER = gql`
  mutation selectSingleUser($id: Int) {
    selectSingleUser(id: $id) @client {
      id
    }
  }
`;

export default SELECT_SINGLE_USER;
